import { useCallback } from "react"
import { convertDistance, getDistance as getDistanceGeolib } from "geolib"

export const useStoreLocator = () => {
  // handles the distance and returns the distance in km.
  const getDistance = useCallback((pos1: any, pos2: any) => {
    if (!pos1 || !pos2) {
      return 0
    }

    return convertDistance(
      getDistanceGeolib({ latitude: pos1.lat, longitude: pos1.lng }, { latitude: pos2.lat, longitude: pos2.lng }),
      "km"
    )
  }, [])

  // handles the geolocation based on browser/device, will prompt for geolocation permission.
  const getCoords = useCallback(async () => {
    try {
      const pos = (await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      })) as GeolocationPosition
      const latLng = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      }

      return latLng
    } catch (error) {
      return null
    }
  }, [])

  return {
    getDistance,
    getCoords,
  }
}
